import {
  AppBootstrapConfig,
} from '@refx/shared-common';

/**
 * DEFAULT specific bootstrap configuration for SSCI
 */
export const SSCI_APP_BOOTSTRAP_CONFIG_DEFAULT: Partial<AppBootstrapConfig> = {
  gatewayClientId: '0WCAPPad3ZpMuglGUlSGYC083zjEsP0Z',
  gatewayClientSecret: 'WkM0wUAm0dcswIEA',
  loggingBaseUrl: 'https://uat.digital-logging.saas.amadeus.com'
};
